/**
 * @copyright Elmelo Ltd.
 */

import React from 'react'

import { Router } from "@reach/router"

import MenuHome from './home'

import P404 from '../_common/404'

/**
 */
class App_Menu extends React.PureComponent
{
    /**
     */
    // constructor( props )
    // {
    //     super( props )
    // }

    /**
     */
    render()
    {
        return (
            <Router>
                <MenuHome path='home'/>

                <P404 default />
            </Router>
            )
    }   // render
}   // class App_Menu

/**
 */
export {App_Menu, MenuHome}
